<template>
  <div class="quill-editor">
    <YToolbar
      ref="toolbar"
      :module="editorOption.modules"
    />
    <div
      :content="value"
      @ready="onEditorReady"
      @change="onEditorChange"
      v-quill:quill="editorOption"
      :style="{ height: height + 'px', width: width + 'px' }">
    </div>
  </div>
</template>

<script>
import Delta from 'quill-delta'
import YToolbar from '@/components/editor/Toolbar'

export default {
  name: 'quill-editor',
  data () {
    return {
      size: '16px',
      color: null,
      editorOption: {
        modules: {
          toolbar: '#toolbar',
          imageImport: true
        },
        placeholder: '请输入内容...',
        theme: 'snow'
      }
    }
  },
  props: {
    width: String,
    height: String,
    value: String,
    module: Object
  },
  methods: {
    onEditorReady (quill) {
      // 消除粘贴的文本的外部链接
      quill.clipboard.addMatcher('a', function(node, delta) {
        return delta.compose(new Delta().retain(delta.length(), { link: false }))
      })
    },
    onEditorChange ({ html, text, quill }) {
      this.$emit('input', html)
      // var imgReg = /<img.*?(?:>|\/>)/gi;
      // var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
      // var arr = html.match(imgReg);  // arr 为包含所有img标签的数组
      // if (html.indexOf("data:image/png;base64") > 0) {
      //      var src = arr[0].match(srcReg)[1];
      //      console.log(src.indexOf("image/png;base64"))
      //      if(src.indexOf("image/png;base64") > 0){
      //       this.$axios._get('/Common/UploadBaseImage', { file: src }).then(res => {
      //           html= html.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,function(){
      //           //console.log(res.url)
      //           var newStr='<img src="'+res.url+'" />';
      //         　　
      //           return newStr;
      //         })
      //         this.$emit('input', html)
      //       })
      //      }else{
      //           this.$emit('input', html)
      //       }
      //     }else{
      //      this.$emit('input', html)
      // }
    }
  },
  components: {
    YToolbar
  }
}
</script>

<style lang="less">
.quill-editor {
  img {
    max-width: 100%;
  }
  .ql-container { background-color: #fff; font-size: 16px; }
}
</style>
